import React from 'react';

const LibrarySearchEmpty = () => {
  return (
    <div className="global-padding-container">
      <div className="px-10 py-16 text-center sm:py-24 lg:py-32 text-smoke">
        <h4 className="stink-h4 ">No results found</h4>
        <p className="mt-4 stink-body-3 lg:mt-6">
          We can’t seem to find any articles matching your search.
        </p>
      </div>
    </div>
  );
};

export default LibrarySearchEmpty;
